module.exports = __webpack_public_path__ + "img/no.3.5bfaf7ef.png";